<template>
	<Card title="趣优品" class="app-list demo-tabs-style2">
		<Tabs type="card" :animated="false">
			<TabPane label="商品架"><Commodity /></TabPane>
			<TabPane label="上线商品列表"><CommoditySell /></TabPane>
		</Tabs>
	</Card>
</template>

<script>
import axios from 'axios';
// 商品架
import Commodity from './Youpin/Commodity.vue';
// 上线商品列表
import CommoditySell from './Youpin/CommoditySell.vue';

export default {
	components: {
		Commodity,
		CommoditySell
	},
	data() {
		return {
			loading: false,
			total: 0,
			current: 1,
			limit: 10,
			columns: [
				{
					title: '商家ID',
					key: 'merchantId',
					sortable: true,
					fixed: 'left',
					width: 120
				},
				{
					title: '商家名称',
					key: 'merchantName',
					width: 120
				},
				{
					title: '标题',
					key: 'title',
					sortable: true,
					width: 200
				},
				{
					title: '总流水',
					key: 'totalFlow',
					sortable: true,
					width: 120
				},
				{
					title: '分成比例',
					key: 'shareRatio',
					width: 120
				},
				{
					title: '创建时间',
					key: 'createTime',
					sortable: true,
					width: 200
				},
				{
					title: '操作',
					key: 'menu',
					slot: 'action',
					fixed: 'right',
					width: 80
				}
			],
			data: []
		};
	},
	mounted() {
	},
	methods: {
		manage(row, index) {
			console.log('管理：', row, index);
		},
		application(row, index) {
			console.log('应用：', row, index);
		},
	}
};
</script>

<style lang="less" scoped>
.app-list {
	flex: 1;
	margin-top: 30px;
	height: max-content;
	> .content {
		background-color: #fff;
		border-radius: 3px;
		box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.05);
		width: 100%;
		box-sizing: border-box;
	}
}
</style>
<style>
.demo-tabs-style2 > .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab {
	border-radius: 0;
	background: #fff;
}
.demo-tabs-style2 > .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab-active {
	border-top: 1px solid #f47d01;
}
.demo-tabs-style2 > .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab-active:before {
	content: '';
	display: block;
	width: 100%;
	height: 1px;
	background: #f47d01;
	position: absolute;
	top: 0;
	left: 0;
}
</style>
